<template>
  <section class="fragment" id="fragment">
    <div class="fragment__mob">
      <img
        class="fragment__mob-img"
        src="@/assets/images/joanna_erbel.png"
        alt="książka"
      />
      <img
        class="fragment__mob-arrow"
        src="@/assets/images/icons/arrow_mob.svg"
        alt="strzałka"
      />
    </div>
       <div class="fragment__first">
      <img
        class="fragment__first-img fragment__first-img--left"
        id="fragment__left"
        src="../../assets/images/joanna_erbel_11.png"
        alt="książka"
      />
      <img
        class="fragment__first-img fragment__first-img--right"
        id="fragment__right"
        src="../../assets/images/joanna_erbel_22.png"
        alt="książka"
      />
    </div>

    <div class="fragment__info content__text" v-html="content.data.fragments.intro">

    </div>
    <div class="fragment__sec">
      <img
        class="fragment__sec-center"
        id="fragment__centert"
        src="../../assets/images/ewa_binczyk.png"
        alt="książka"
      />
           <img
        class="fragment__mob-arrow"
        src="@/assets/images/icons/arrow_mob.svg"
        alt="strzałka"
      />
    </div>
    <h2 class="fragment__title" v-html="content.data.fragments.header">
    </h2>
    <div class="fragment__desc content__text" v-html="content.data.fragments.content">
    </div>
    <div class="fragment__cta ">
      <Button :text="content.data.fragments.btn" /> 
    </div>
  </section>
</template>

<script>
  import Button from "../elements/Button.vue";
export default {
  text: "BookFragments",
  components: {
    Button,
  },
  inject: ['content'],
  methods: {
    handleSCroll() {
      let bookLeft = document.getElementById("fragment__left");
      let bookRight = document.getElementById("fragment__right");
      let bookHeight = document.getElementById("fragment").clientHeight / 2;
      let bookScroll = bookLeft.getBoundingClientRect().top + bookHeight;
      if (
        window.scrollY > bookScroll &&
        !bookLeft.className.includes("animationFrag")
      ) {
        bookLeft.classList.add("animationFrag");
        bookRight.classList.add("animationFrag");
      }
    },
    
   
  },
  created() {
    window.addEventListener("scroll", this.handleSCroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleSCroll);
  },
};
</script>
